<template>
    <div
        class="notification-banner-wrapper g-container"
        :class="{
            'closing' : isClosing,
            'warning' : isWarning,
            'success' : isSuccess,
            'error' : isError
        }"
    >
        <div class="content">
            <div class="icon">
                <img
                    :src="require(`@/assets/img/banner-icon/${bannerType || 'success'}.png`)"
                    class="success-icon"
                >
            </div>

            <div class="message">
                <div class="header">
                    <span>
                        {{ title }}
                    </span>
                </div>
                <p>{{ bannerMessage }}</p>
            </div>

            <div class="close">
                <span @click="close()">
                    &times;
                </span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters({
			bannerStatus: 'getBannerStatus',
			bannerMessage: 'getBannerMessage',
			bannerType: 'getBannerType'
		}),

		title () {
			return this.$options.filters.capitalize(this.bannerType)
		},

		isSuccess () {
		    return this.bannerType === 'success'
		},
		isWarning () {
		    return this.bannerType === 'warning'
		},
		isError () {
		    return this.bannerType === 'error'
		}
	},

	data () {
		return {
			isClosing: false
		}
	},

	mounted () {
		setTimeout(() => this.autoClose(), 3000)
	},

	methods: {
		autoClose () {
			if (!this.isClosing) {
				this.isClosing = true
				setTimeout(() => this.$store.dispatch('toggleBanner', { status: false }), 1000)
			}
		},

		close () {
			this.autoClose()
		}
	}
}
</script>

<style lang="scss" scoped>
.notification-banner-wrapper {
    position: fixed;
    top: 60px;
    right: 0;
    left: 0;
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    z-index: 999;
    pointer-events: none;

    .content {
        position: relative;
        display: flex;
        align-items: center;
        background: #fff;
        box-shadow: 0 0 24px rgba(0,0,0,0.15);
        border-radius: 5px;
        width: 465px;
        padding: 10px;
        pointer-events: all;

        @include fadeinright(0.5s,0s);

        .icon {
            padding: 0 5px;

            img {
                width: 24px;
                height: auto;
            }
        }

        .message {
            flex: 1 1 auto;
            padding: 0 20px;

            .header {
                span {
                    font-size: 16px;
                    font-weight: 700;
                    color: #4A4C50;
                }
            }

            p {
                margin-top: 5px;
                font-size: 14px;
                font-style: italic;
                color: #979CAC;
            }
        }

        .close {
            padding: 10px;
            cursor: pointer;

            span {
                color: #979CAC;
                font-size: 24px;
            }
        }
    }

    &.success {
        .content {
            border-left: 10px solid #29C27C;
        }
    }

    &.warning {
        .content {
            border-left: 10px solid #F8C51B;
        }
    }

    &.error {
        .content {
            border-left: 10px solid #f54b5e;
        }
    }

    &.closing {
        .content {
            @include fadeoutright(0.5s,0s);
        }
    }
}
</style>
